import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { COMPARATIVA } from '../../data/content';
export function Comparison() {
  return <section className="bg-crema-alt py-16 sm:py-20 px-5" data-id="element-63" data-mp="34qsxhfdnbhix">
      <div className="max-w-4xl mx-auto" data-id="element-64" data-mp="30nmuqhpqs8h7">
        <h2 className="font-serif text-3xl sm:text-4xl font-bold text-violeta text-center leading-tight" data-id="element-65" data-mp="30mlb3ounudnv">
          En qué se diferencia de otros cuadernillos
        </h2>

        <div className="mt-10 overflow-x-auto rounded-3xl bg-white shadow-sm border border-black/5" data-id="element-66" data-mp="2qr0de2wmjzjx">
          <table className="w-full text-left border-collapse" data-id="element-67" data-mp="2lyqgg2x3dz85">
            <caption className="sr-only" data-id="element-68" data-mp="2gzxb4xrylej2">
              Comparación entre otros cuadernillos y el Kit de Caligrafía
            </caption>
            <thead data-id="element-69" data-mp="2d0er047yp7ha">
              <tr className="bg-violeta text-crema" data-id="element-70" data-mp="2cwqwp2up0h1i">
                <th scope="col" className="px-4 sm:px-6 py-4 font-semibold text-sm sm:text-base" data-id="element-71" data-mp="2800i6jyjdti7">
                  Concepto
                </th>
                <th scope="col" className="px-4 sm:px-6 py-4 font-semibold text-sm sm:text-base" data-id="element-72" data-mp="232qtx7mvvnvy">
                  Otros cuadernillos
                </th>
                <th scope="col" className="px-4 sm:px-6 py-4 font-semibold text-sm sm:text-base" data-id="element-73" data-mp="3pbgwqzke69l6">
                  Este kit
                </th>
              </tr>
            </thead>
            <tbody data-id="element-74" data-mp="3ghlrzsn6ml62">
              {COMPARATIVA.map((fila, i) => <tr key={fila.concepto} className={i % 2 === 1 ? 'bg-crema' : 'bg-white'} data-id="element-75" data-mp="3gfr3638si8wp" data-mpi={i}>
                  <th scope="row" className="px-4 sm:px-6 py-4 font-semibold text-tinta text-sm sm:text-base" data-id="element-76" data-mp="807i3ri9vwsq">
                    {fila.concepto}
                  </th>
                  <td className="px-4 sm:px-6 py-4 text-tinta/55 text-sm sm:text-base" data-id="element-77" data-mp="32yxzldkdiou">
                    <span className="inline-flex items-center gap-2" data-id="element-78" data-mp="2iud1tkc8knxq">
                      <MinusIcon className="w-4 h-4" aria-hidden="true" data-id="element-79" data-mp="2iwfyuobt3hby" />
                      {fila.otros}
                    </span>
                  </td>
                  <td className="px-4 sm:px-6 py-4 text-violeta font-semibold text-sm sm:text-base" data-id="element-80" data-mp="23rldajk772da">
                    <span className="inline-flex items-center gap-2" data-id="element-81" data-mp="1zqt0jgc4afc9">
                      <CheckIcon className="w-4 h-4 text-dorado" aria-hidden="true" data-id="element-82" data-mp="1uyrrs4e5r6qz" />
                      {fila.kit}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}